import { createAction, props } from '@ngrx/store';
import { Dropdown } from '../../models/dropdown';

export const getRateTypes = createAction('[Rate Type] get rate types');
export const getRateTypesSuccess = createAction(
  '[Rate Type] get rate types success',
  props<{ rateTypes: Dropdown[] }>()
);
